import { SidebarItemStub, SidebarSection, Stub, VStack } from '@direct-frontend/components';
import styles from './DashboardSidebarStub.module.css';

export const DashboardSidebarStub = () => (
    <VStack className={styles.sidebar}>
        <div className={styles.logo}>
            <Stub width={140} height={40} borderRadius="8" />
        </div>
        <SidebarSection>
            <SidebarItemStub />
            <SidebarItemStub />
            <SidebarItemStub />
            <SidebarItemStub />
            <SidebarItemStub />
            <SidebarItemStub />
            <SidebarItemStub />
        </SidebarSection>
        <SidebarSection>
            <SidebarItemStub />
            <SidebarItemStub />
        </SidebarSection>
        <SidebarSection>
            <SidebarItemStub />
        </SidebarSection>
    </VStack>
);
